import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getCentPrice, tryParseMonetaryValue } from '../../../../helpers/general';
import { confirmationMessages } from '../../../../constants/text';

export default class TipAmount extends Component {
  static propTypes = {
    addTips: PropTypes.func.isRequired
  };

  state = {
    tip_amount: ''
  };

  setTipsAmount = e => {
    const resolvedValue = tryParseMonetaryValue(e.target.value);
    if (!_.isNull(resolvedValue)) {
      this.setState({ tip_amount: resolvedValue });
    }
  };

  handleSubmit = () => {
    const tip_amount = getCentPrice(this.state.tip_amount);
    this.props.addTips(tip_amount);
  };

  render () {
    const { tip_amount } = this.state;
    return (
      <React.Fragment>
        <h4 className='tip-rate-title'>
          <label htmlFor='tip-amount-input-id'>Tip Amount</label>
        </h4>
        <input
          id='tip-amount-input-id'
          className='tip-rate-input'
          type='number'
          min='0'
          step='any'
          value={tip_amount}
          onChange={this.setTipsAmount}
        />
        <p className='tip-info-message'>{confirmationMessages.taxOnTips}</p>
        <button
          className={`button button-primary mt-4 submit-tips-rates-button ${tip_amount ? '' : 'disabled'}`}
          onClick={this.handleSubmit}
        >Submit</button>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/TipAmount.js